import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal } from "@/components/bits";
import { LANDING_FAQS } from "@/config/store";

// FAQ — ivory accordion cards, trimmed to the six purchase-critical
// questions so the section stays scannable. Copy lives in config/store.js.
export default function FaqStore() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="bg-white">
      <div className="px-4 py-12 sm:py-16 max-w-2xl mx-auto w-full">
        <Reveal>
          <p className="font-body font-bold text-[11px] tracking-[0.22em] uppercase text-ink/50">
            QUICK ANSWERS
          </p>
          <h2 className="mt-3 font-display uppercase leading-[0.95] text-[10.5vw] sm:text-5xl">
            Fair <span className="text-[#FF6BAA]">questions.</span>
          </h2>
        </Reveal>
        <Reveal className="mt-7" delay={0.03}>
          <div className="space-y-2">
            {LANDING_FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className="rounded-2xl border-2 border-ink/10 bg-ivory"
                >
                  <button
                    data-testid={`faq-question-${i + 1}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-4 py-4 text-left"
                  >
                    <span className="font-display uppercase tracking-wide text-base leading-tight">
                      {f.q}
                    </span>
                    <ChevronDown
                      className={`w-5 h-5 shrink-0 transition-transform duration-200 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      strokeWidth={2.5}
                    />
                  </button>
                  {isOpen && (
                    <p
                      data-testid={`faq-answer-${i + 1}`}
                      className="px-4 pb-4 text-sm sm:text-base text-ink/70 max-w-md"
                    >
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
